import React, { useEffect, useState } from 'react';
import Header from '../components/header';
import Nav from '../components/Navigation';
import { FaWhatsapp } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { GrCopy } from "react-icons/gr";
import Modal from 'react-bootstrap/Modal';
import Bottomtab from '../components/BottomTab'
import ProfileSEO from '../components/seo-components/ProfileSEO'

import { Helmet } from "react-helmet";

import '../assets/css/profile.css'

const ProfilePage = () => {
  const navigate = useNavigate();
  const user = localStorage.getItem('user');
  const parsedUser = JSON.parse(user);
  useEffect(() => {
    if (!user) {
      // console.log("inside ifuser",user);
      navigate('/');
    }
  },);

  const handleGoToWebsite = () => {
    // console.log("handle Go To Bet Pro website Button");
  }
  const handleLogout = () => {
    // console.log("logout triggered");
    localStorage.removeItem('user');
    // console.log("user removed", localStorage.getItem('user'));
    navigate('/', { replace: true });
  }

  const handledepositclick = () => {
    navigate('/deposit')
  }
  const handlewithdrawclick = () => {
    navigate('/withdraw')
  }

  const handleCopyClick = (copyTxt) => {

    setMsg(copyTxt + ' copied successfully');
    handleShow();
  };


  const [show, setShow] = useState(false);
  const [Msg, setMsg] = useState('');

  const handleShow = () => setShow(true);

  const handleClose = function () {
    setShow(false);


  };


  return (
    <div>



    <ProfileSEO />


      <Header />





      

      <div className="login-wrapper">
        <div className="main-login">
          <div className="container" style={{ padding: "0 1rem", maxWidth: "28rem" }}>

            <div className="row align-items-top">
              <div className="col-12">
                <div className="left-login-box1">
                  <div className="fieldset">
                    <div className="title mb-4">

                      <div className="account3 mt-3">
                        <h3>Personal profile</h3>
                        <div className="info mt-3 mb-3">
                          <p>
                            <strong className="mb-3 ">Name:</strong>
                            <span className="mb-3 right">{parsedUser.name}</span>
                          </p>
                          <p>
                            <strong className="mb-3 ">Email:</strong>
                            <span className="mb-3 right">{parsedUser.email}</span>
                          </p>
                          <p>
                            <strong className="mb-3 ">Whatappp Number</strong>
                            <span className="mb-3 right">{parsedUser.number}</span>
                          </p>

                        </div>


                       
                      </div>
                    </div>
                  </div>



                </div>
              </div>
            </div>

            <div className="confirm-deposit w-full my-10 mt-3">
                <button type="submit" onClick={handleLogout}>Logout</button>
              </div>


          </div>
        </div>
      </div>
     
     

      {/* <Nav /> */}

      <Bottomtab />

      {/* Modal for messages */}
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header >
          <Modal.Title>Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{Msg}</p>
          <hr />
          <p onClick={handleClose} className="model-ok">Ok</p>
        </Modal.Body>

      </Modal>

    </div>
  )
}

export default ProfilePage;
